import Link from 'next/link';
import type { CatalogMaterial } from './materialCatalogGroups';
import { haulCategoryKey, haulCategoryLabel } from './materialCatalogGroups';
import { weightLabel, type WeightUnit } from '@/domains/paydirt/materialUnits';
import { catalogPlaceholderClass, catalogPlaceholderLabel } from './materialCatalogPlaceholder';

export type MaterialCatalogCardProps = {
  material: CatalogMaterial;
  priceSummary?: string | null;
};

export function MaterialCatalogCard({ material, priceSummary }: MaterialCatalogCardProps) {
  const href = `/materials/${material.materialId}/`;
  const categoryKey = haulCategoryKey(material);
  const placeholderClass = catalogPlaceholderClass(categoryKey);

  return (
    <article className="material-catalog-card">
      <Link href={href} className="material-catalog-card__media">
        {material.imageUrl ? (
          <div
            className="material-catalog-card__image"
            style={{ backgroundImage: `url('${material.imageUrl}')` }}
            aria-hidden
          />
        ) : (
          <div className={`material-catalog-card__placeholder ${placeholderClass}`} aria-hidden>
            {catalogPlaceholderLabel(categoryKey)}
          </div>
        )}
      </Link>
      <div className="material-catalog-card__body">
        <div className="material-catalog-card__meta">
          <h3 className="material-catalog-card__title">
            <Link href={href}>{material.displayName}</Link>
          </h3>
          <span className="material-catalog-card__formula">{material.scientificName || '—'}</span>
          <span className="material-catalog-card__badge">{haulCategoryLabel(material)}</span>
          <span className="material-catalog-card__unit">{weightLabel(material.weightUnit as WeightUnit)}</span>
        </div>
        {priceSummary ? <p className="material-catalog-card__price text-muted">{priceSummary}</p> : null}
      </div>
    </article>
  );
}
